import { snackbar } from '../../services/display-notification'
import type { SnackbarNotification } from '../../services/display-notification/models'
import { getTranslation } from '../../services/i18n/i18nUtils'
import { UserDoNotDisturb } from '../../services/presence'

const getDndNotification = (): SnackbarNotification => ({
  id: 'snackbar_dnd',
  title: getTranslation('All notifications silenced'),
  message: getTranslation("You're now blocking notifications for calls, messages, and meeting reminders."),
  dataTest: 'enable-DND',
})

const getNotDndNotification = (): SnackbarNotification => ({
  id: 'snackbar_not_dnd',
  title: getTranslation('All notifications turned on'),
  message: getTranslation("You're no longer blocking notifications for calls, messages, and meeting reminders."),
  dataTest: 'disable-DND',
})

export const displayDNDSnackbar = (currentStatus: UserDoNotDisturb) => {
  const notification =
    currentStatus === UserDoNotDisturb.DO_NOT_DISTURB ? getDndNotification() : getNotDndNotification()
  snackbar(notification)
}
